import axios from 'axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { API_URL } from '../../config';
import * as ActionTypes from './Actiontype';

export const getEmployer = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_EMPLOYER_INIT,
    });

    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.get(`${API_URL}/api/employer/`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data) {
        dispatch({
          type: ActionTypes.GET_EMPLOYER_SUCCESS,
          payload: res?.data,
        });
      } else {
        dispatch({
          type: ActionTypes.GET_EMPLOYER_FAIL,
          payload: res.data.message || 'Task data not get!',
        });
      }
    } catch (e) {
      dispatch({
        type: ActionTypes.GET_EMPLOYER_FAIL,
        payload: typeof e === 'string' ? e : '',
      });
    }
  };
};

export const addEmployer = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: ActionTypes.ADD_EMPLOYER_INIT,
    });
    const token = localStorage.getItem('authToken');
    axios
      .post(`${API_URL}/api/admin/employer/bulk`, payload, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch({
            type: ActionTypes.ADD_EMPLOYER_SUCCESS,
            payload: res.data,
          });
          // dispatch(getEmployer());
          toast.success('Employer added successfully ');
          resolve(res);
        } else {
          dispatch({
            type: ActionTypes.ADD_EMPLOYER_FAIL,
            payload: res.data?.message || 'Failed to send Otp',
          });
          toast.error('can not add employer');
        }
      })
      .catch((error) => {
        console.log('error', error);
        resolve(error);
      });
  });
};

export const deleteEmployer = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: ActionTypes.DELETE_EMPLOYER_INIT,
    });
    const token = localStorage.getItem('authToken');
    axios
      .delete(`${API_URL}/api/employer/${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch({
            type: ActionTypes.DELETE_EMPLOYER_SUCCESS,
            payload: res.data,
          });
          toast.success('employer deleted successfully');
          dispatch(getEmployer());
          resolve(res);
        } else {
          dispatch({
            type: ActionTypes.DELETE_EMPLOYER_FAIL,
            payload: res.data?.message || 'Failed to send Otp',
          });
          toast.error('can not delete employer ');
        }
      })
      .catch((error) => {
        console.log('error', error);
        resolve(error);
      });
  });
};

// single employer

export const getSingleEmployer = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_SINGLE_EMPLOYER_INIT,
    });
    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.get(`${API_URL}/api/employer/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status === 200) {
        dispatch({
          type: ActionTypes.GET_SINGLE_EMPLOYER_SUCCESS,
          payload: res.data.data,
        });
      } else {
        dispatch({
          type: ActionTypes.GET_SINGLE_EMPLOYER_FAIL,
          payload: res.data.message,
        });
      }
    } catch (e) {
      dispatch({
        type: ActionTypes.GET_SINGLE_EMPLOYER_FAIL,
        payload: typeof e === 'string' ? e : '',
      });
    }
  };
};

export const SearchEmployer = (payload, limits, pages, startdate, enddate) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.SEARCH_EMPLOYER_INIT,
    });

    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.post(
        `${API_URL}/api/employer/fetch`,
        {
          search: payload,
          limit: limits,
          page: pages,
          startDate: startdate,
          endDate: enddate,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data) {
        dispatch({
          type: ActionTypes.SEARCH_EMPLOYER_SUCCESS,
          payload: res?.data,
        });
      } else {
        dispatch({
          type: ActionTypes.SEARCH_EMPLOYER_FAIL,
          payload: res.data.message || 'Task data not get!',
        });
      }
    } catch (e) {
      dispatch({
        type: ActionTypes.SEARCH_EMPLOYER_FAIL,
        payload: typeof e === 'string' ? e : '',
      });
    }
  };
};

// update employer

// export const updateEmployer = (id, payload) => {
//   return async (dispatch) => {
//     dispatch({
//       type: ActionTypes.EDIT_EMPLOYER_INIT,
//     });
//     const token = localStorage.getItem('authToken');
//     try {
//       const res = await axios.put(`${API_URL}/api/employer/${id}`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.status === 200) {
//         dispatch({
//           type: ActionTypes.EDIT_EMPLOYER_SUCCESS,
//           payload: res.data,
//         });
//         toast.success('employer details updated successfully ');
//         dispatch(SearchEmployer());
//       } else {
//         dispatch({
//           type: ActionTypes.EDIT_EMPLOYER_FAIL,
//           payload: res.data.message,
//         });
//         toast.error('can not update employer');
//       }
//     } catch (e) {
//       dispatch({
//         type: ActionTypes.EDIT_EMPLOYER_FAIL,
//         payload: typeof e === 'string' ? e : '',
//       });
//     }
//   };
// };

export const updateEmployer = (id, payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: ActionTypes.EDIT_EMPLOYER_INIT,
    });
    const token = localStorage.getItem('authToken');
    axios
      .put(`${API_URL}/api/employer/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch({
            type: ActionTypes.EDIT_EMPLOYER_SUCCESS,
            payload: res.data,
          });
          resolve(res);
          toast.success('employee updated successfully ');
        } else {
          dispatch({
            type: ActionTypes.EDIT_EMPLOYER_FAIL,
            payload: res.data?.message || 'Failed to send Otp',
          });
          toast.error('can not add employee ');
        }
      })
      .catch((error) => {
        console.log('error', error);
        resolve(error);
      });
  });
};
